import { Icon } from "./Icon.tsx";

/** A clockwise curved arrow, the mirror of UndoIcon. */
export function RedoIcon() {
  return (
    <Icon>
      <path d="m15 14 5-5-5-5" />
      <path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13" />
    </Icon>
  );
}
